import EthIcon from '../assets/icons/ethereum-logo.webp';
import ArbitrumIcon from '../assets/icons/arbitrum-logo.svg';
import RskIcon from '../assets/icons/rootstock-logo.svg';

const DRAWER_WIDTH = 180;
const DRAWER_WIDTH_TABLET = 140;
const DRAWER_WIDTH_MOBILE = 120;

export function getDrawerWidth(isMobile: boolean, isTablet: boolean): number {
  return isMobile ? DRAWER_WIDTH_MOBILE : (isTablet ? DRAWER_WIDTH_TABLET : DRAWER_WIDTH);
}

export const chainIcons: Record<string, string> = {
    ETH: EthIcon,
    ARB: ArbitrumIcon,
    RSK: RskIcon,
};